var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[_vm.circle ? 'cropper-yuan' : '']},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"id":"image","src":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }